"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FullCreditPriceTooltip = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./FullCreditTooltip.css"));
var _FullCreditPriceModal = require("../FullCreditPriceModal");
var _uiKit = require("@cian/ui-kit");
var _icons = require("@cian/ui-kit-design-tokens/icons");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const FullCreditPriceTooltip = props => {
  const {
    tooltip,
    placement = 'bottom',
    trackClickHandler,
    onTooltipClose
  } = props;
  const [open, setOpen] = React.useState(false);
  const onClick = React.useCallback(e => {
    e.stopPropagation();
    if (trackClickHandler) {
      trackClickHandler();
    }
    setOpen(true);
  }, [trackClickHandler]);
  const clickTrap = React.useCallback(e => {
    e.stopPropagation();
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    desktop: true,
    tablet: true
  }, /*#__PURE__*/React.createElement("div", {
    className: style['icon'],
    onClick: clickTrap
  }, /*#__PURE__*/React.createElement(_uiKit.InformationTooltip, {
    content: /*#__PURE__*/React.createElement("div", {
      className: style['tooltip']
    }, /*#__PURE__*/React.createElement(_uiKit.ArticleHeading4, null, "\u041F\u043E\u043B\u043D\u0430\u044F \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u043A\u0440\u0435\u0434\u0438\u0442\u0430"), /*#__PURE__*/React.createElement(_uiKit.UIText2, {
      whiteSpace: "pre-wrap"
    }, tooltip)),
    theme: "white",
    placement: placement,
    onClose: onTooltipClose
  }, /*#__PURE__*/React.createElement("div", {
    className: style['icon--inner'],
    onClick: trackClickHandler
  }, /*#__PURE__*/React.createElement(_icons.IconFunctionalInformation16, {
    color: "icon-main-default"
  }))))), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    phone: true
  }, /*#__PURE__*/React.createElement("div", {
    className: style['icon'],
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: style['icon--inner']
  }, /*#__PURE__*/React.createElement(_icons.IconFunctionalInformation16, {
    color: "icon-main-default"
  })))), /*#__PURE__*/React.createElement(_FullCreditPriceModal.FullCreditPriceModal, {
    onOpenChange: setOpen,
    open: open,
    title: "\u041F\u043E\u043B\u043D\u0430\u044F \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u043A\u0440\u0435\u0434\u0438\u0442\u0430",
    description: tooltip
  }));
};
exports.FullCreditPriceTooltip = FullCreditPriceTooltip;